export function LegalAboutSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight mb-3 font-[family-name:var(--font-heading)]">
        AI agent infrastructure for regulated industries.
      </h2>
      <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-6">
        COSX builds AI agent infrastructure for regulated industries worldwide. We give businesses a platform to deploy, manage, and govern AI agents with built-in compliance, audit trails, and professional oversight.
      </p>
      <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-8">
        Our agents are live in legal services and education, with financial services in development. The platform is the same. The compliance layer adapts to each industry.
      </p>

      {/* Three stat cards */}
      <div className="flex gap-4">
        {[
          { value: "2", label: "Products live", detail: "Legal services and education" },
          { value: "3", label: "Countries", detail: "UK, Australia, New Zealand" },
          { value: "15+", label: "Firms on the platform", detail: "Live in production since 2025" },
        ].map((stat) => (
          <div key={stat.label} className="flex-1 border border-[var(--color-border)] px-5 py-5 rounded-sm">
            <div className="text-[40px] font-light tracking-tight font-[family-name:var(--font-heading)] mb-1">
              {stat.value}
            </div>
            <div className="text-[10px] font-[family-name:var(--font-mono)] tracking-widest uppercase text-[var(--color-fg-tertiary)] mb-1">
              {stat.label}
            </div>
            <div className="text-[11px] text-[var(--color-fg-tertiary)]">
              {stat.detail}
            </div>
          </div>
        ))}
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          We don&apos;t sell tools. We deploy AI agents that work under your compliance rules.
        </p>
      </div>
    </div>
  );
}
